__turbopack_context__.v({
  "colorShift": "Hero-module__ZARIfG__colorShift",
  "container3d": "Hero-module__ZARIfG__container3d",
  "dataStream": "Hero-module__ZARIfG__dataStream",
  "enhanced3dContainer": "Hero-module__ZARIfG__enhanced3dContainer",
  "gradientShift": "Hero-module__ZARIfG__gradientShift",
  "grid": "Hero-module__ZARIfG__grid",
  "hero3dContainer": "Hero-module__ZARIfG__hero3dContainer",
  "hero3dFeaturesWrapper": "Hero-module__ZARIfG__hero3dFeaturesWrapper",
  "heroButton": "Hero-module__ZARIfG__heroButton",
  "heroButtonContainer": "Hero-module__ZARIfG__heroButtonContainer",
  "heroColorCycle": "Hero-module__ZARIfG__heroColorCycle",
  "heroFeatureItem": "Hero-module__ZARIfG__heroFeatureItem",
  "heroFeaturesContainer": "Hero-module__ZARIfG__heroFeaturesContainer",
  "heroFeaturesGrid": "Hero-module__ZARIfG__heroFeaturesGrid",
  "heroGradientShift": "Hero-module__ZARIfG__heroGradientShift",
  "heroGrid": "Hero-module__ZARIfG__heroGrid",
  "heroPrimaryButton": "Hero-module__ZARIfG__heroPrimaryButton",
  "heroPrimaryStatsCard": "Hero-module__ZARIfG__heroPrimaryStatsCard",
  "heroPrimaryStatsLabel": "Hero-module__ZARIfG__heroPrimaryStatsLabel",
  "heroPrimaryStatsValue": "Hero-module__ZARIfG__heroPrimaryStatsValue",
  "heroSecondaryButton": "Hero-module__ZARIfG__heroSecondaryButton",
  "heroSecondaryStatsCard": "Hero-module__ZARIfG__heroSecondaryStatsCard",
  "heroSecondaryStatsLabel": "Hero-module__ZARIfG__heroSecondaryStatsLabel",
  "heroSecondaryStatsValue": "Hero-module__ZARIfG__heroSecondaryStatsValue",
  "heroStatsCard": "Hero-module__ZARIfG__heroStatsCard",
  "heroStatsContainer": "Hero-module__ZARIfG__heroStatsContainer",
  "heroStatsLabel": "Hero-module__ZARIfG__heroStatsLabel",
  "heroStatsValue": "Hero-module__ZARIfG__heroStatsValue",
  "heroStatsWrapper": "Hero-module__ZARIfG__heroStatsWrapper",
  "heroTextContainer": "Hero-module__ZARIfG__heroTextContainer",
  "heroTitleAnimated": "Hero-module__ZARIfG__heroTitleAnimated",
  "heroTitleGlow": "Hero-module__ZARIfG__heroTitleGlow",
  "holoGlow": "Hero-module__ZARIfG__holoGlow",
  "neuralGrid": "Hero-module__ZARIfG__neuralGrid",
  "pulse": "Hero-module__ZARIfG__pulse",
  "responsive3dHeight": "Hero-module__ZARIfG__responsive3dHeight",
  "section": "Hero-module__ZARIfG__section",
  "streamFlow": "Hero-module__ZARIfG__streamFlow",
  "textContainer": "Hero-module__ZARIfG__textContainer",
});
